import { IMPERSONATION_USER_TOKEN_LOGIN_FAILED, IMPERSONATION_USER_TOKEN_LOGIN_INIT, IMPERSONATION_USER_TOKEN_LOGIN_SUCCESS } from "./constants";
const initialState = {
  loading: false,
  token: "",
  isTFVRequired: false,
  isPhoneVerified: true,
  userId: null,
};

export default function Impersonationlogin(state = initialState, action) {
  switch (action.type) {
    case IMPERSONATION_USER_TOKEN_LOGIN_INIT:
      return { ...state, loading: true };
    case IMPERSONATION_USER_TOKEN_LOGIN_SUCCESS:
      return { ...state, loading: false };
    case IMPERSONATION_USER_TOKEN_LOGIN_FAILED:
      return { ...state, loading: false };
        default:
      return state;
  }
}
